import { Fragment, useEffect } from "react";
import { persianLanguage } from "../../../../constants/persianTerms";
import {
    DatePicker,
} from "react-advance-jalaali-datepicker";

import "./SimpleDatePickerInput.css"

  
export default function SimpleDatePickerInput({
    changeDate,
    selectedDate,
    unixDate,
}){
    useEffect(() =>{
    }, [selectedDate, unixDate]);

    return (
        <Fragment>
            <DatePicker

            placeholder={`${persianLanguage.word.general.SELECT} ${persianLanguage.word.general.DATE}`}
            format="jYYYY/jMM/jDD"
            onChange={changeDate}
            customClass="custom-datepicker-input rmdp-container"
            containerClass="custom-datepicker-input"
            
            id="datePicker"

            inputClass="custom-datepicker-input"
            // containerClass="custom-datepicker-container"
            />
        </Fragment>
    );
}